import PropTypes from 'prop-types';
import React from 'react';
import MenuButton from '../menu_button.ui';

export function SectionsMenu({
    onSelection,
    disabled = false,
    sections,
    fromSection,
}) {
    const renderSection = section => {
        return (
            <span key={section.id}>
                {`${section.course_catalog_number} - ${section.course_title} #${
                    section.class_number
                }`}
            </span>
        );
    };

    const onSelectInt = selection => {
        onSelection(parseInt(selection, 10));
    };

    return (
        <MenuButton
            disabled={disabled}
            items={sections}
            value={fromSection}
            onSelection={onSelectInt}
            renderItem={renderSection}
        >
            Select a section...
        </MenuButton>
    );
}
SectionsMenu.propTypes = {
    onSelection: PropTypes.func,
    disabled: PropTypes.bool,
    sections: PropTypes.array,
    fromSection: PropTypes.number,
};

export function TermsMenu({ onSelection, terms, fromTerm }) {
    const renderTerm = term => {
        return <span key={term.id}>{term.name}</span>;
    };

    const onSelectInt = selection => {
        onSelection(parseInt(selection, 10));
    };

    return (
        <MenuButton
            items={terms}
            value={fromTerm}
            onSelection={onSelectInt}
            renderItem={renderTerm}
        >
            Select a term...
        </MenuButton>
    );
}
TermsMenu.propTypes = {
    onSelection: PropTypes.func,
    terms: PropTypes.array,
    fromTerm: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/copy_materials_dialog/menus.jsx